import * as React from 'react';

import { type SupportedLanguage } from 'lib/lexemes/supported-languages';
import { Provider as LocaleProvider } from 'lib/locale-context';
import Localization, { LocalizationProvider } from 'lib/localization';
import { AppProps as BaseAppProps } from 'next/app';

import ComponentSeo from 'components/page-seo/page-seo';

export type AppProps = {
  Component: BaseAppProps['Component'];
  pageProps: { lang: SupportedLanguage };
};

function AppContainer({ Component, pageProps }: AppProps) {
  const lexemes = getLexemes(pageProps.lang);

  return (
    <LocaleProvider value={pageProps.lang}>
      <LocalizationProvider
        instance={Localization}
        lang={pageProps.lang}
        entries={lexemes.lexemes}
        commonWords={lexemes.common}
      >
        <ComponentSeo />
        <Component {...pageProps} />
      </LocalizationProvider>
    </LocaleProvider>
  );
}

function getLexemes(lang: SupportedLanguage) {
  return require(`lib/lexemes/${lang}`).default;
}

export default AppContainer;
